type ProgressBarProps = {
    type?: 'horizontal' | 'vertical';
    className?: string;
    value?: number | string;
    total?: number | string;
};

const ProgressBar: React.FC<ProgressBarProps> = ({
    type = 'horizontal',
    className = '',
    value = 50,
    total = 100,
}) => {
    const percentage = +value / +total;

    return (
        <div className={`progress-bar ${type} ${className}`}>
            <div
                className='current-value'
                style={{
                    [type === 'horizontal' ? 'width' : 'height']: `${percentage * 100}%`,
                }}
            />
        </div>
    );
};

export default ProgressBar;
